import { render, staticRenderFns } from "./Queues.vue?vue&type=template&id=3b6b1d3d&scoped=true&"
import script from "./Queues.vue?vue&type=script&lang=js&"
export * from "./Queues.vue?vue&type=script&lang=js&"
import style0 from "./Queues.vue?vue&type=style&index=0&id=3b6b1d3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6b1d3d",
  null
  
)

export default component.exports